import {
  ESelfServeTaskStatus,
  ETaskId,
  TaskCategories
} from 'common/contracts';
import { setupChecklistStateService } from 'state/setup-checklist.state.service';

import { ISetupChecklistCategory, ISetupChecklistTaskAction } from './types';

export const getCategoryStatus = (
  taskStatuses: ESelfServeTaskStatus[]
): ESelfServeTaskStatus => {
  const unique = Array.from(new Set(taskStatuses));

  if (unique.length === 1) return unique[0];

  if (unique.every((status) => status === ESelfServeTaskStatus.OPEN))
    return ESelfServeTaskStatus.OPEN;
  if (unique.every((status) => status === ESelfServeTaskStatus.PENDING))
    return ESelfServeTaskStatus.PENDING;
  if (unique.every((status) => status === ESelfServeTaskStatus.DONE))
    return ESelfServeTaskStatus.DONE;

  if (unique.includes(ESelfServeTaskStatus.OPEN))
    return ESelfServeTaskStatus.IN_PROGRESS;
  if (
    unique.every(
      (status) =>
        status === ESelfServeTaskStatus.DONE ||
        status === ESelfServeTaskStatus.PENDING
    )
  )
    return ESelfServeTaskStatus.PENDING;

  return ESelfServeTaskStatus.IN_PROGRESS; // fallback for unexpected combinations
};

export const checklistInitialCategories: ISetupChecklistCategory[] = [
  {
    title: TaskCategories.CHECKOUT,
    tasks: [
      {
        id: ETaskId.EDIT_CHECKOUT_IN_BUILDER,
        title: 'Open Builder tab & edit the Checkout',
        action: ({ navigate, publisherId }: ISetupChecklistTaskAction) => {
          navigate(`/project/${publisherId}/theme/checkout`);
        }
      }
    ]
  },
  {
    title: TaskCategories.VERIFY_BUSINESS,
    tasks: [
      {
        id: ETaskId.VERIFY_BUSINESS_CONTACT,
        title: 'Submit your company contact info',
        action: ({ toggleChecklist }) => {
          toggleChecklist();
          setupChecklistStateService.setIsVerifyBusinessModalOpen(true);
        }
      }
    ]
  },
  {
    title: TaskCategories.DOCUMENTATION,
    tasks: [
      {
        id: ETaskId.READ_DOCUMENTATION,
        title: 'Learn more about the checkout',
        action: ({ markTaskAsDone }) => {
          window.open(
            'https://docs.appcharge.com/guides/ios-payment-links/about-ios-payment-links',
            '_blank'
          );
          markTaskAsDone();
        }
      }
    ]
  },
  {
    title: TaskCategories.TEST_PAYMENTS,
    tasks: [
      {
        id: ETaskId.TEST_PAYMENTS,
        title: 'Make an order and test payments',
        action: ({ navigate, publisherId }: ISetupChecklistTaskAction) => {
          navigate(`/project/${publisherId}/settings/integration`);
        }
      }
    ]
  },
  {
    title: TaskCategories.SIGN_AGREEMENT,
    tasks: [
      {
        id: ETaskId.SIGN_AGREEMENT,
        title: 'Review and sign the Appcharge Agreement',
        action: ({ toggleChecklist }) => {
          toggleChecklist();
          setupChecklistStateService.setIsSendAgreementModalOpen(true);
        }
      }
    ]
  },
  {
    title: TaskCategories.GO_LIVE,
    tasks: [
      {
        id: ETaskId.GO_LIVE,
        title: 'Go live with checkout'
      }
    ],
    tooltip: 'Complete mandatory steps to unlock production.'
  }
];
